(function () {
  /* ---------- 3D tilt on each slide's product image ---------- */
  document.querySelectorAll('.pico-intro__visual').forEach(function (visual) {
    var wrap = visual.querySelector('.pico-intro__img-wrap');
    if (!wrap) return;

    var currentX = 0, currentY = 0;
    var targetX = 0, targetY = 0;
    var rafId = null;

    function animate() {
      currentX += (targetX - currentX) * 0.07;
      currentY += (targetY - currentY) * 0.07;
      wrap.style.transform =
        'perspective(900px) rotateY(' + currentX + 'deg) rotateX(' + (-currentY) + 'deg) scale(1.04)';
      rafId = requestAnimationFrame(animate);
    }

    visual.addEventListener('mouseenter', function () {
      if (!rafId) animate();
    });

    visual.addEventListener('mousemove', function (e) {
      var rect = visual.getBoundingClientRect();
      var dx = (e.clientX - (rect.left + rect.width / 2)) / (rect.width / 2);
      var dy = (e.clientY - (rect.top + rect.height / 2)) / (rect.height / 2);
      targetX = dx * 10;
      targetY = dy * 8;
    });

    visual.addEventListener('mouseleave', function () {
      targetX = 0;
      targetY = 0;
    });
  });

  /* ---------- Hero carousel: swipe + filling progress lines ---------- */
  var carousel = document.querySelector('.pico-hero');
  if (!carousel) return;

  var track = carousel.querySelector('.pico-hero__track');
  var slides = carousel.querySelectorAll('.pico-hero__slide');
  var bars = carousel.querySelectorAll('.pico-hero__bar');
  if (!track || slides.length < 2) return;

  var current = 0;
  var lockUntil = 0;
  var scrollTimer = null;

  function setActive(index) {
    current = index;
    bars.forEach(function (bar, i) {
      bar.classList.remove('is-active', 'is-done');
      if (i < index) bar.classList.add('is-done');
      if (i === index) {
        void bar.offsetWidth; /* restart the fill animation */
        bar.classList.add('is-active');
      }
    });
  }

  function goTo(index) {
    lockUntil = Date.now() + 700;
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    setActive(index);
  }

  /* line finished filling -> move to the next slide (loops back to the first) */
  carousel.addEventListener('animationend', function (e) {
    if (!e.target.classList.contains('pico-hero__bar-fill')) return;
    goTo((current + 1) % slides.length);
  });

  /* user swiped / dragged */
  track.addEventListener('scroll', function () {
    if (Date.now() < lockUntil) return;
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      if (idx !== current) setActive(idx);
    }, 80);
  }, { passive: true });

  /* click a line to jump to that slide */
  bars.forEach(function (bar, i) {
    bar.addEventListener('click', function () { goTo(i); });
  });

  /* pause while a finger is down */
  carousel.addEventListener('touchstart', function () {
    carousel.classList.add('is-paused');
  }, { passive: true });
  ['touchend', 'touchcancel'].forEach(function (evt) {
    carousel.addEventListener(evt, function () {
      setTimeout(function () { carousel.classList.remove('is-paused'); }, 400);
    }, { passive: true });
  });

  /* pause while the hero is off-screen */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      carousel.classList.toggle('is-offscreen', !entries[0].isIntersecting);
    }, { threshold: 0.4 }).observe(carousel);
  }

  /* keep the current slide aligned on resize / rotate */
  window.addEventListener('resize', function () {
    track.scrollLeft = current * track.clientWidth;
  });

  setActive(0);
})();